import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Grid, IconButton, Paper, Typography, Box, FormHelperText, Stack, Divider, Alert, TextField, AlertTitle } from '@mui/material';

import Terms from '../../../src/components/saving-league/t&c';

import Button from '@mui/material/Button';
import LoginPopUp from '../../components/saving-league/login-popup';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CongratulationsPopup from '../../components/saving-league/congratulation';
import CongratulationsPopupRepeat from '../../components/diwali/congratulationRepeat';


const HeroSection = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/herosection.png";
const EarnPoints = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/earn.png";
const Assured = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/assured.png";
const Footer = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/footer.png";
const TermImg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/Term-img.png";
export default function Signup() {
    // login popup
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
const navigate = useNavigate();
    const ck_id = localStorage.getItem('savings_league_ck_id_sep')

    useEffect(() => {
        document.body.classList.remove('no-scroll');
        checkUserRegistration();
    }, [])

    const checkUserRegistration = async () => {
        const params = new URLSearchParams(window.location.search);
        let userId = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid');
        
        // If no userId in URL, check localStorage
        if (!userId) {
            userId = localStorage.getItem('savings_league_ck_id_sep');
        }
        
        if (userId && userId !== "null") {
            try {
                // Check if user is already registered via API
                const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl?ck_id=${userId}`);
                const data = await response.json();
                
                if (data && data.user_data && data.user_data.user) {
                    // Check if user segment is 5 (not eligible)
                    if (data.user_data?.user?.segment === 5) {
                        setIsNotEligible(true);
                        console.log('User segment is 5, not eligible');
                        return;
                    }
                    
                    // User is already registered, redirect to index
                    localStorage.setItem('savings_league_ck_id_sep', userId);
                    navigate('/savings-league/index', { replace: true });
                    setShowRepeatPopup(true);
                    setOpenRepeatPopup(true);
                    console.log('User already registered, redirecting to index');
                } else {
                    // User not registered, show signup form
                    console.log('User not registered, showing signup form');
                }
            } catch (error) {
                console.error('Error checking user registration:', error);
                // On error, show signup form
            }
        } else {
            // No userId found, show signup form
            console.log('No userId found, showing signup form');
        }
    }


    const handleCloseLoginPopup = () => {
        setShowLoginPopup(false);
    };
    const handleClosePopup = () => {
        setOpenPopup(false);
        setOpenRepeatPopup(false);
    };
    const [checked, setChecked] = useState(true);
    const [showError, setShowError] = useState(false);
    const [openPopup, setOpenPopup] = useState(false)
    const [openRepeatPopup, setOpenRepeatPopup] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const [showRepeatPopup, setShowRepeatPopup] = useState(false)
    const [showLoginPopup, setShowLoginPopup] = useState(false)
    const [isNotEligible, setIsNotEligible] = useState(false)

    const handleChange = (event) => {
        setChecked(event.target.checked);
        setShowError(false); // Reset error when the checkbox is checked
    };

    const handleSubmit = async () => {
        if (!checked) {
            setShowError(true); // Show error if the checkbox is not checked
        } else {
            const params = new URLSearchParams(window.location.search);
            let ck_id = params.get('userid') || params.get('user_id') || params.get('userId') || params.get('ck_id') || params.get('ckid')
            console.log(ck_id)
            
            if (ck_id != null && ck_id != "null") {
                // First check if user is already registered
                try {
                    const checkResponse = await fetch(`https://leaderboard-1.earningshub.co/api/user/getleaderboard_cdl?ck_id=${ck_id}`);
                    const checkData = await checkResponse.json();
                    
                    if (checkData && checkData.user_data && checkData.user_data.user) {
                        // User is already registered, redirect to index
                        localStorage.setItem('savings_league_ck_id_sep', ck_id);
                        navigate('/savings-league/index', { replace: true });
                        console.log('User already registered, redirecting to index');
                        return;
                    }
                } catch (error) {
                    console.error('Error checking existing registration:', error);
                }
                
                // User not registered, proceed with registration
                try {
                    const response = await fetch(`https://leaderboard-1.earningshub.co/api/user/create_cdl?${ck_id ? `userId=${ck_id}` : ''}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                    const data = await response.json();

                    if (data.status === 1) {
                        localStorage.setItem('savings_league_ck_id_sep', data?.ck_id);
                        setShowPopup(true)
                        setOpenPopup(true)
                    } else {
                        console.log('Registration response:', data);
                        
                        // Check if user is not eligible (segment_type: 5)
                        if (data.error === 1 && data.segment_type === 5) {
                            setIsNotEligible(true);
                            console.log('User not eligible - segment_type:', data.segment_type);
                            return;
                        }
                        
                        // If registration failed, check if user was already registered
                        if (data.message && data.message.includes('already')) {
                            localStorage.setItem('savings_league_ck_id_sep', ck_id);
                            navigate('/savings-league/index', { replace: true });
                        }
                    }
                } catch (error) {
                    console.error('Error:', error);
                    alert('An error occurred. Please try again.');
                }
            } else {
                navigate('/savings-league/index', { replace: true })

                // Force the new page to start at the top
                requestAnimationFrame(() => {
                    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
                });
            }
        }
    };
    const scrollToElementt = () => { formReff.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
    const formReff = useRef(null);


    return (
        <Grid container sx={{ background: '#fff'}}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} onClick={()=>console.log('auyfhlua')}>
                    <>
                        <Grid item xs={12}>
                        <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/one.png" alt='HeroSection' style={{ width: '100%', }} />
                        </Grid>
                 <Grid item xs={12}><img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/two.png" alt='Assured' style={{ width: '100%', }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/section3.png" alt='EarnPoints' style={{ width: '100%', }} />
                                </Grid>
                                <Grid item xs={12}>
                                    <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/four.png" alt='AboutPrize' style={{ width: '100%', }} />
                
                                </Grid>
                                <Grid item xs={12}>
                                    <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/five.png" alt='AboutPrize' style={{ width: '100%', }} />
                
                                </Grid>
                <Grid item xs={12} ref={formReff}>
                    <Box px={5} pt={3} pb={4}>
                        <img src={TermImg} alt='termImg' width={'100%'} />
                    </Box>

                    <Terms dynamicCss={{ color: "#000" }} /> 
                </Grid>

                <Grid item xs={12} mt={3}>

                    <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/footer.png" alt="Footer" style={{ width: '100%', marginBottom: '108px' }} />

                </Grid>
                
                {/* Not Eligible Message */}
                {isNotEligible && (
                    <Grid item xs={12} sx={{ 
                        position: 'fixed', 
                        top: 0, 
                        left: 0, 
                        right: 0, 
                        bottom: 0, 
                        backgroundColor: 'rgba(0,0,0,0.8)', 
                        zIndex: 999999999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Box sx={{ 
                            backgroundColor: '#fff', 
                            padding: 4, 
                            borderRadius: 2, 
                            textAlign: 'center',
                            maxWidth: '300px',
                            margin: 2
                        }}>
                            <Typography sx={{ 
                                fontSize: '18px', 
                                fontWeight: 'bold', 
                                color: '#d32f2f',
                                marginBottom: 2
                            }}>
                                Sorry, you are not eligible
                            </Typography>
                            <Typography sx={{ 
                                fontSize: '14px', 
                                color: '#666',
                                marginBottom: 3
                            }}>
                                You are not eligible to participate in this campaign.
                            </Typography>
                            <Button 
                                variant="contained" 
                                onClick={() => window.close()}
                                sx={{ 
                                    backgroundColor: '#d32f2f',
                                    '&:hover': { backgroundColor: '#b71c1c' }
                                }}
                            >
                                Close
                            </Button>
                        </Box>
                    </Grid>
                )}
                {!showPopup && !showRepeatPopup && !showLoginPopup && !isNotEligible && <Grid container sx={{ position: 'relative', zIndex: '999999999', backgroundColor: '#fff' }}>
                    <Grid item xs={12} sm={12} md={4} lg={4} sx={{
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                        backgroundColor: '#fff', // Set background color explicitly here
                        paddingX: '16px', // Add padding if needed for better spacing
                        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)', // Optional: Add shadow to give it a "floating" effect
                    }}
                    >
                        <FormControlLabel
                            sx={{
                                // Remove margin from the root element if needed
                                marginRight: '0px !important', // This affects space on the right, update or remove as necessary
                                '& .MuiFormControlLabel-label': {
                                    marginLeft: '0px' // This will reduce space between the checkbox and its label
                                }
                            }}
                            control={
                                <Checkbox
                                    checked={checked}
                                    onChange={handleChange}
                                    sx={{
                                        color: '#0036DA',
                                        '&.Mui-checked': { color: '#0036DA' },
                                        marginLeft: '0px' // If the checkbox itself has any left margin, this will remove it
                                    }}
                                />
                            }
                        />

                        <span style={{
                            color: '#262626',
                            fontFamily: 'Metropolis',
                            fontSize: '12px',
                            fontStyle: 'normal',
                            fontWeight: '600',
                            lineHeight: '16px', /* 133.333% */
                            marginLeft: '0px' // This ensures no left margin for the span text if it's outside the FormControlLabel
                        }}>
                            I agree to the T&Cs of the campaign listed <span style={{ color: 'blue' }}><a onClick={scrollToElementt}>here</a></span>.
                            {/* <Link href="#" color="primary"> here </Link>. */}
                        </span>
                        {showError && (
                            <Typography color="error" sx={{ marginTop: '0px', fontSize: '12px', fontFamily: 'Metropolis' }}>
                                You must agree to the terms and conditions to proceed.
                            </Typography>
                        )}

                        <Box sx={{ marginBottom: '1rem' }}>
                            <Button
                                onClick={() => handleSubmit()}
                                variant="contained"
                                sx={{
                                    width: '100%',
                                    backgroundColor: '#0036DA',
                                    borderRadius: '12px',
                                    color: '#fff',
                                    height: '48px',
                                    padding: '16px',
                                    fontWeight: '700',
                                    fontSize: '14px',
                                    fontFamily: 'Metropolis',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    '&:hover': {
                                        backgroundColor: '#0041a3',
                                    },
                                }}
                            >
                                Register Now
                            </Button>
                        </Box>

                    </Grid>
                </Grid>}
                    </>
            </Grid>


            {/* {showRepeatPopup && <>
                <CongratulationsPopupRepeat open={openRepeatPopup} onClose={handleClosePopup} />
            </>} */}

            {showPopup && <>
                <CongratulationsPopup open={openPopup} onClose={handleClosePopup} />
            </>}
            <LoginPopUp open={showLoginPopup} onClose={handleCloseLoginPopup} />
            <Grid item xs={12} sm={12} md={4} lg={4}>
            </Grid>
        </Grid>

    )
};